import { Icon } from "@iconify-icon/react";

export const Counter = ({
  count,
  onIncrement,
  onDecrement,
}: {
  count: number;
  onIncrement?: () => void;
  onDecrement?: () => void;
}) => {
  return (
    <div className="flex items-center space-x-3">
      <button
        title="-"
        onClick={onDecrement}
        className="size-5 flex justify-center items-center rounded-full bg-[#F3F3F3] hover:bg-[#F3F3F3] focus:outline-none">
        <Icon
          icon={"hugeicons:remove-01"}
          className="text-[#414141] font-bold stroke-2"
          width={13}
        />
      </button>
      <span className="text-sm font-bold min-w-4">{count}</span>
      <button
        title="+"
        onClick={onIncrement}
        className="size-5 flex justify-center items-center rounded-full bg-[#F3F3F3] hover:bg-[#F3F3F9] focus:outline-none">
        <Icon icon={"hugeicons:add-01"} className="text-[#414141]" width={13} />
      </button>
    </div>
  );
};
